export interface ProjectReport {
  id: number;
  title: string;
  notes: string | null;
  file_name: string;
  file_size: number;
  mime_type: string | null;
  uploaded_by_user_id: number | null;
  uploaded_by_name: string | null;
  created_at: string;
  updated_at: string;
  can_edit: boolean;
  can_delete: boolean;
}

export interface ProjectReportsResponse {
  reports: ProjectReport[];
  can_manage: boolean;
}

export type ProjectReportFileType = 'pdf' | 'document' | 'spreadsheet' | 'presentation' | 'image' | 'archive' | 'other';

export const PROJECT_REPORT_FILE_TYPES: { type: ProjectReportFileType; extensions: string[]; icon: string }[] = [
  { type: 'pdf', extensions: ['pdf'], icon: 'picture_as_pdf' },
  { type: 'document', extensions: ['doc', 'docx', 'txt'], icon: 'description' },
  { type: 'spreadsheet', extensions: ['xls', 'xlsx', 'csv'], icon: 'table_chart' },
  { type: 'presentation', extensions: ['ppt', 'pptx'], icon: 'slideshow' },
  { type: 'image', extensions: ['png', 'jpg', 'jpeg'], icon: 'image' },
  { type: 'archive', extensions: ['zip'], icon: 'folder_zip' },
];

export const PROJECT_REPORT_ACCEPTED_EXTENSIONS = PROJECT_REPORT_FILE_TYPES.flatMap((entry) => entry.extensions);
export const PROJECT_REPORT_MAX_SIZE_BYTES = 50 * 1024 * 1024;

export function projectReportFileType(fileName: string): ProjectReportFileType {
  const extension = (fileName || '').split('.').pop()?.toLowerCase() ?? '';
  return PROJECT_REPORT_FILE_TYPES.find((entry) => entry.extensions.includes(extension))?.type ?? 'other';
}

export function projectReportFileIcon(fileName: string): string {
  const type = projectReportFileType(fileName);
  return PROJECT_REPORT_FILE_TYPES.find((entry) => entry.type === type)?.icon ?? 'insert_drive_file';
}
